import {
  Home,
  Contact,
  Accessoires,
  Strickereien,
  Sitzkissen,
  Wolle,
  Spinnkurse,
  Termine,
  Impressum,
  Datenschutz,
} from "../routes";

const routes = [
  { text: "Home", to: "/", component: Home },
  {
    text: "Galerie",
    to: [
      {
        text: "Sitzkissen",
        to: "/galerie/sitzkissen",
        component: Sitzkissen
      },
      { text: "Wolle", to: "/galerie/wolle", component: Wolle },
      { text: "Strickereien", to: "/galerie/strickereien", component: Strickereien },
      {
        text: "Accessoires",
        to: "/galerie/accessoires",
        component: Accessoires
      }
    ]
  },
  
  { text: "Termine", to: "/termine", component: Termine },
  { text: "Spinnkurse", to: "/spinnkurse", component: Spinnkurse },
  { text: "Kontakt", to: "/contact", component: Contact },
  { text: "Impressum", to: "/impressum", component: Impressum, hide: true },
  {
    text: "Datenschutz",
    to: "/datenschutz",
    component: Datenschutz,
    hide: true
  }
];

export default routes;
